PegasusTemplate.CanvasController = Ember.Controller.extend({
  needs: ['toolbar', 'editing', 'blockOperations', 'socialFollow', 'rowOperations', 'application'],
  shouldShowImageReplacerBinding: 'controllers.application.shouldShowImageReplacer',
  editedBinding: Ember.Binding.oneWay('controllers.editing.edited'),
  editedFragmentBinding: Ember.Binding.oneWay('controllers.editing.content'),
  selectedRowColorBinding: 'controllers.toolbar.selectedRowColor',
  themeRowColor: 'controllers.toolbar.selectedTheme.bodyRowColor'
});

PegasusTemplate.CanvasController.reopenClass({
  createModel: function( newRecord, element ){
    var model = this.decorateModel( newRecord, element );
    return model;
  },

  decorateModel: function( params, element ){
    if( params.html && params.recordType === 'Image' ) {
      params.dataSrc = $( params.html ).attr('src') || $( params.html ).find('img').attr('src');
    }

    return $.extend(params, PegasusTemplate.Helpers.collectDataAttributes( element ));
  }
});
